<div class="actions-menu">
  @if (titleAction) {
    <a
      class="cell-title cell-title--link"
      role="link"
      tabindex="0"
      (click)="onTitleClick($event)"
      (keydown.enter)="onTitleClick($event)"
      >{{ title }}</a
    >
  } @else {
    <span class="cell-title">{{ title }}</span>
  }
  @if (visibleItems().length) {
    <a
      class="dropdown-toggle-btn"
      [suiMenuTrigger]="actionsMenu"
      (openChange)="onToggle($event)"
      (click)="$event.stopPropagation()"
    >
      <fa-icon
        [icon]="['fas', 'bars']"
        [class.active]="dropdownVisible"
      ></fa-icon>
    </a>
  }
  <ng-template #actionsMenu>
    <sui-menu>
      @for (item of visibleItems(); track $index) {
        @if (isSeparator(item)) {
          <sui-menu-separator></sui-menu-separator>
        } @else {
          <button
            sui-menu-item
            [disabled]="isDisabled(item)"
            (click)="onItemClick(item, $event)"
          >
            @if (item.icon) {
              <fa-icon [icon]="item.icon"></fa-icon>
            }
            <span>{{ item.label }}</span>
          </button>
        }
      }
    </sui-menu>
  </ng-template>
</div>

@if (!title && title !== "") {
  <div>N/A</div>
}
